import { type ContentComponent, type EmailSubscribeFormPlaceholderContent } from '../../../../types/construct.types';
import { Divider } from '../../../common-components/divider/divider.component';

export const HorizontalDividerPlaceholder: ContentComponent<EmailSubscribeFormPlaceholderContent> = () => (
	<div className="w-100">
		<Divider horizontalSpacing={0} verticalSpacing={4} />
	</div>
);
